import { coreApi } from './api';

export default async function fetchForecastHistoryData({
	accessToken,
	selectedDate,
	countryId,
	selectedOwner,
	page,
	pageSize,
	search,
	selectedMotive,
	selectedMargin,
	selectedYear,
	selectedMarketplace,
}) {
	const res = await coreApi.get('/historico', {
		params: {
			countryId,
			pagesize: pageSize,
			pagenum: page,
			creadorid_maestro: selectedOwner,
			fecha: selectedDate !== 'IGNORE' ? selectedDate : undefined,
			productname: search !== '' ? search : undefined,
			motivo_id: selectedMotive,
			margen: selectedMargin,
			year: selectedYear,
			marketplace_id: selectedMarketplace,
		},
		headers: {
			Authorization: `Bearer ${accessToken}`,
			accept: '*/*',
		},
	});

	const items =
		res?.data?.data?.map((item) => ({
			...item,
			id: `${item?.hdate}-${item?.country_id}-${item?.product_id}-${item?.cm_creador_id}-${item?.marketplace_id}`,
		})) || [];
	const count = res?.data?.count;

	return { items, count };
}
